$(() => {
  $('#get-started').click(function(e){
    e.preventDefault();
    var $target = $('html,body');
    const $scrollTo = $('#select-a-school').offset().top;
    $target.animate({scrollTop: $scrollTo - 10 }, 500);
  });
});
